import styled from 'styled-components';

import QueryStringRetriever from '../../../../utils/QueryStringRetriever';

import { getHideTopbar, setHideTopbar } from '../../../../utils/SettingsRetriever';

import _variables from '../themeVariables';

export default (system) => {
    const variables = _variables(system);

    let background = `background-color: ${variables.general_background_color};`;

    if(system.assets && system.assets.background){
        background = `
            background-image: url(${system.assets.background});
            background-size: cover;
            background-position: top center;
            background-attachment: fixed;
            background-repeat: no-repeat;
        `;
    }

    if (system.assets && system.assets.backgroundFullColor) background = `background-color: ${system.assets.backgroundFullColor};`; 

    const hideTopbar = () => {
        if (QueryStringRetriever().hasOwnProperty('no-topbar')) {
            setHideTopbar(QueryStringRetriever()['no-topbar']);
            if (QueryStringRetriever()['no-topbar'] === true) return true;
            else  return false;
        }
        if (getHideTopbar() === true) return true;
        return false;
    }
    
    if (QueryStringRetriever().hasOwnProperty('no-topbar')) setHideTopbar(true);

    return styled.div`
        ${background}
        @media only screen and (max-width: 991px) {
            .viewWrapper {
                top: ${hideTopbar() ? '0' : '50'}px !important;
                min-height: ${hideTopbar() ? '100vh' : 'calc(100vh - 50px)'} !important;
            }
            .mobilesearch {
                top: ${hideTopbar() ? '0' : '47'}px !important;
            }
        }
        .myrewardsSection {
            .welcomeClaim {
                svg, svg > path {
                    fill: ${variables.rewards_icon_fill_color} !important;
                }
            }
            .actionsClaim {
                .LoggedIn {
                    button {
                        background-color: ${variables.rewards_button_background};
                        color: ${variables.rewards_button_color};
                    }
                }
            }
        }
        .attachGuest {
            button.primary, button.AddButton, button.detachGuest {
                border-color: ${variables.b2b_login_cta_border};
                background-color: ${variables.b2b_login_cta_background};
                color: ${variables.b2b_login_cta_color};
            }
            .MuiFormControlLabel-root {
                span {
                    span {
                        svg {
                            color: ${variables.b2b_login_cta_background};
                        }
                    }
                }
            }
        }
        .InsidePopup {
            .desktopRooms {
                background: ${variables.item_lodging_unit_booknow_cta_background};
                color: ${variables.item_lodging_unit_booknow_cta_color};
            }
        }
        .CalendarDay__selected{
            background-color:${variables.searchbar_calendarDay_selected_background};
            border-color:${variables.searchbar_calendarDay_selected_background};
            &:hover{
                background-color:${variables.searchbar_calendarDay_selected_background_hover};
                border-color:${variables.searchbar_calendarDay_selected_background_hover};
            }
        }
        .CalendarDay__selected_span, .CalendarDay__last_in_range{
            background-color:${variables.searchbar_calendarDay_selected_background_hover};
            border-color:${variables.searchbar_calendarDay_selected_background_hover};
            border-style:unset;
            &:hover{
                background-color:${variables.searchbar_calendarDay_betweenRange_background};
                border:${variables.searchbar_calendarDay_betweenRange_background};
                color: ${variables.searchbar_calendarDay_betweenRange_color};
            }
        }
        .CalendarDay__hovered_span, .CalendarDay__hovered_span:hover{
            background-color:${variables.searchbar_calendarDay_betweenRange_background};
            border:${variables.searchbar_calendarDay_betweenRange_background};
            color: ${variables.searchbar_calendarDay_betweenRange_color};
        }
        .boxedTopbarWrapper {
            .content {
                background-color: ${variables.topbar_background_color};
            }
            .cartIcon{
                .cartCounter {
                    background-color: ${variables.topbar_cartcounter_background};
                    color: ${variables.topbar_cartcounter_color};
                    border-color: ${variables.topbar_cartcounter_border}
                }
            }
        }
        .searchingScreenBackground, .noResultsBackground {
            @media(max-width: 991px) {
                ${background}
            }
        }
        .searchingScreen, .noResultsScreen {
            color: ${variables.searching_screen_color};
            background-color: ${variables.searching_screen_background_color};
        }
        .topbarWrapper, .newTopbarWrapper{
            display: ${hideTopbar() ? 'none' : 'block'};
            background-color: ${variables.topbar_background_color};
            box-shadow: ${variables.topbar_shadow};
            @media(min-width: 992px) {
                &.transparent{
                    background-color: transparent;
                }
            }
            .container{
                .cartBadge{
                    background-color: ${variables.topbar_cartwrapper_background};
                    color: ${variables.topbar_cartwrapper_color};
                }
                .cartIcon{
                    .cartCounter {
                        background-color: ${variables.topbar_cartcounter_background};
                        color: ${variables.topbar_cartcounter_color};
                        border-color: ${variables.topbar_cartcounter_border}
                    }
                    svg{
                        fill: ${variables.topbar_cartwrapper_color};
                    }
                }
                .options{
                    .message{
                        color: ${variables.topbar_message_color};
                        bold, a{
                            color: ${variables.topbar_message_bold_color};
                        }
                    }
                    .links, .menuItems{
                        ul li a, ul li button, .menuItem a {
                            color: ${variables.topbar_message_link_color};
                        }
                    }
                    .HeaderWrapper{
                        .SwitchesWrapper{
                            .TopBarSwitches{
                                background-color: ${variables.b2b_topbar_switches_background};
                                button{
                                    color: ${variables.b2b_topbar_switches_nonselected_color};
                                    background-color: ${variables.b2b_topbar_switches_nonselected_background};
                                    &.selected{
                                        background-color: ${variables.b2b_topbar_switches_selected_background};
                                        color: ${variables.b2b_topbar_switches_selected_color};
                                    }
                                }
                            }
                        }
                        .tatoButtons{
                            .tatoButton{
                                .avatar{
                                    background-color: ${variables.b2b_topbar_buttons_background};
                                    color: ${variables.b2b_topbar_buttons_color};
                                    svg{
                                        fill: ${variables.b2b_topbar_buttons_color};
                                    }
                                }
                            }
                        }
                    }
                }
            }
            @media (max-width: 991px){
                background-color: ${variables.topbar_mobile_background};
                .menu{
                    svg{
                        fill: ${variables.topbar_menu_icon};
                    }
                }
                .container{
                    .cart{
                        .has-badge{
                            color: ${variables.topbar_badge_color};
                        }
                        svg{
                            fill: ${variables.topbar_cart_icon};
                        }
                    }
                }
            }
        }
        .navWrapper{
            padding-top: 20px;
            margin-top: 0px;
            .container{
                button,
                .headerTab{
                    background-color: ${variables.navbar_tab_background};
                    color: ${variables.navbar_tab_color};
                    border-color: ${variables.navbar_tab_border};
                    svg{
                        fill: ${variables.navbar_tab_color};
                    }
                    &.active,&.active:hover{
                        background-color: ${variables.navbar_tab_active_background};
                        color: ${variables.navbar_tab_active_color};
                        svg{
                            fill: ${variables.navbar_tab_active_color};
                        }
                    }
                    &:hover{
                        background-color: ${variables.navbar_tab_hover_background};
                        color: ${variables.navbar_tab_hover_color};
                        svg{
                            fill: ${variables.navbar_tab_hover_color};
                        }
                    }
                    &.cartButton{
                        background-color: ${variables.navbar_tab_shoppingcart_background};
                        color: ${variables.navbar_tab_shoppingcart_color};
                    }
                }
            }
        }
        .searchWrapper{
            .container{
                .search{
                    background-color: ${variables.searchbar_background};
                    color: ${variables.searchbar_color};
                    .searchBox{
                        .SingleDatePickerInput, .DateRangePickerInput{
                            border-color: ${variables.searchbar_input_border};
                            background-color: ${variables.searchbar_input_background};
                            .DateRangePickerInput_arrow_svg{
                                fill: ${variables.searchbar_input_color};
                            }
                            .DateInput{
                                background: ${variables.searchbar_input_background};
                                .DateInput_input{
                                    background: ${variables.searchbar_input_background};
                                    color: ${variables.searchbar_input_color};
                                }
                            }
                            .SingleDatePickerInput_calendarIcon{
                                svg{
                                    fill: ${variables.searchbar_input_color};
                                }
                            }
                        }
                        .MonthRegion {
                            border-color: ${variables.searchbar_input_border};
                            background-color: ${variables.searchbar_input_background};
                            color: ${variables.searchbar_input_color};
                            svg{
                                fill: ${variables.searchbar_input_color};
                            }
                        }
                        .MuiInputBase-root{
                            border-color: ${variables.searchbar_input_border};
                            background-color: ${variables.searchbar_input_background};
                            color: ${variables.searchbar_input_color};
                            svg{
                                fill: ${variables.searchbar_input_color};
                            }
                        }
                        .searchAction{
                            .searchButton{
                                background: ${variables.searchbar_button_background};
                                color: ${variables.searchbar_button_color};
                                border: 1px solid ${variables.searchbar_button_border}
                                &:hover{
                                    background: ${variables.searchbar_button_background_hover};
                                    color: ${variables.searchbar_button_color_hover};
                                }
                            }
                        }
                    }
                }
            }
            .mobilesearch{
                .searchform, .filter, .listMenuSortby{
                    background-color: ${variables.mobilesearch_background};
                    color: ${variables.mobilesearch_color};
                }
                .searchform, .filter{
                    border-right-color: rgba(0, 0, 0, 0.2);
                    svg{
                        fill: ${variables.mobilesearch_color};
                    }
                }
                .filter, .listMenuSortby{
                    border-left-color: rgba(255, 255, 255, 0.2);
                    svg{
                        fill: ${variables.mobilesearch_color};
                    }
                }
                .ButtonWrapper, .applyFilters{
                    background: ${variables.searchbar_button_background};
                    color: ${variables.searchbar_button_color};
                    .MuiButton-root{
                        color: ${variables.searchbar_button_color};
                    }
                }
                .resetFilters[class]{
                    border-color: ${variables.searchbar_button_background};
                    color: ${variables.searchbar_button_background};
                }
            }
        }
        .breadcrumb {
            .step.active {
                background-color: ${variables.breacrumb_active_background};
                color: ${variables.breacrumb_active_color};
                border-color: transparent transparent transparent ${variables.breadcrumb_active_background};
                .stepCount {
                    border-color: ${variables.breacrumb_active_count_border_color};
                }
            }
            .step.notpassed {
                background-color: ${variables.breacrumb_disabled_background};
                color: ${variables.breacrumb_disabled_color};
                .stepCount {
                    border-color: ${variables.breacrumb_disabled_count_border_color};
                }
            }
            .step.passed {
                background-color: ${variables.breadcrumb_previous_background};
                color: ${variables.breadcrumb_previous_color};
                .stepCount {
                    border-color: ${variables.breadcrumb_previous_count_border_color};
                }
            }
            .step.active:not(.last){
                &::before{
                    border-left-color: ${variables.breacrumb_active_border_color};
                }
                &::after{
                    border-left-color: ${variables.breacrumb_active_background};
                }
            }
            .step.notpassed:not(.last){
                &::before{
                    border-left-color: ${variables.breacrumb_disabled_border_color};
                }
                &::after{
                    border-left-color: ${variables.breacrumb_disabled_background};
                }
            }
            .step.passed:not(.last){
                &::before{
                    border-left-color: ${variables.breadcrumb_previous_border_color};
                }
                &::after{
                    border-left-color: ${variables.breadcrumb_previous_background};
                }
            }
        }
        .PromocodePage {
            .content {
                h1 {
                    color: ${variables.promocode_title_main_color};
                    .weak {
                        color: ${variables.promocode_title_weak_color};
                    }
                }
                .btnSend {
                    color: ${variables.promocode_button_color};
                    border: 1px solid ${variables.promocode_button_border};
                    background: ${variables.promocode_button_background};
                    &:hover{
                        color: ${variables.promocode_button_color_hover};
                        background: ${variables.promocode_button_background_hover};
                    }
                }
            }
        }
        .lodgingSection{
            background-color: ${variables.lodginglist_background};
            .content{
                .fullmobilemap{
                    .togglemapbutton{
                        background-color: ${variables.map_button_background_color};
                        border-color: ${variables.map_button_border_color};
                        color: ${variables.map_button_color};
                    }
                }
            }
            .sidebar{
                .filter{
                    .head{
                        background-color: ${variables.lodginglist_filter_head_background};
                        color: ${variables.lodginglist_filter_head_color};
                    }
                    .content{
                        background-color: ${variables.lodginglist_filter_content_background};
                        .MuiCheckbox-root.Mui-checked{
                            svg{
                                fill: ${variables.lodginglist_filter_content_checkbox_color};
                            }
                        }
                    }
                    &.byPrice{
                        .content{
                            .input-range{
                                .input-range__label{
                                    color: ${variables.lodginglist_filter_content_slider_label_color};
                                }
                                .input-range__track{
                                    background: ${variables.lodginglist_filter_content_slider_track_color};
                                }
                                .input-range__track--active{
                                    background: ${variables.lodginglist_filter_content_slider_track_active_color};
                                }
                                .input-range__slider{
                                    background: ${variables.lodginglist_filter_content_slider_track_point_background};
                                    border-color: ${variables.lodginglist_filter_content_slider_track_point_border};
                                }
                            }
                        }
                    }
                    .MuiTypography-body1{
                        span{
                            color: ${variables.lodginglist_filter_neighborhood_color} !important;
                        }
                    }
                }
            }
            .results{
                .MuiDivider-root{
                    background-color: ${variables.item_lodging_border_color};
                }
                .loadMore{
                    background: ${variables.item_lodging_primary_cta_background};
                    color: ${variables.item_lodging_primary_cta_color};
                    border-color: ${variables.item_lodging_primary_cta_border};
                    &:hover{
                        background: ${variables.item_lodging_primary_cta_background_hover};
                        color: ${variables.item_lodging_primary_cta_color_hover};
                        svg{
                            fill:${variables.item_lodging_primary_cta_color_hover};
                        }
                    }
                }
            }
        }
        .activitiesSection, .merchandiseSection, .carRentalsSection{
            .content{
                .results{
                    background-color: ${variables.activitylist_background};
                    .filters{
                        .filter{
                            svg{
                                fill:${variables.activities_filters_color};
                            }
                            border-color: ${variables.activities_filters_border};
                            &:not(:last-child){
                                border-right:1px solid #dddddd;
                            }
                            background-color: ${variables.activities_filters_background};
                            color: ${variables.activities_filters_color};
                        }
                    }
                    .supplier{
                        color: ${variables.activities_filters_modal_color};
                    }
                }
            }
        }
        .inAppSection{
            .searchBox{
                button{
                    background-color: ${variables.item_inapp_mobilesearch_buttonBackground};
                    color: ${variables.item_inapp_mobilesearch_buttonForeground};
                }
            }
            .searchWrapper .mobilesearch .listMenuSortby, .searchform[class]{
                background-color: ${variables.item_inapp_tabbar_background};
                color: ${variables.item_inapp_tabbar_foreground};
            }
            .content{
                .results{
                    background-color: ${variables.activitylist_background};
                    .supplier{
                        color: ${variables.activities_filters_modal_color};
                    }
                }
            }
            .tabBarProduct{
                background-color: ${variables.item_inapp_tabbar_background};
                .tabOption{
                    color: ${variables.item_inapp_tabbar_foreground};
                }
                .MuiTabs-indicator{
                    background-color: ${variables.item_inapp_tabbar_foreground};
                }
            }
        }
        .landingSection, .landingCarRentalsSection{
            .searchButton{
                background: ${variables.searchbar_button_background};
                color: ${variables.searchbar_button_color};
                border: 1px solid ${variables.searchbar_button_border}
                &:hover{
                    background: ${variables.searchbar_button_background_hover};
                    color: ${variables.searchbar_button_color_hover};
                }
            }
        }
        .flightsSection, .carRentalsSection{
            .mobilesearch{
                .searchform, .filter, .listMenuSortby{
                    background-color: ${variables.mobilesearch_background};
                    color: ${variables.mobilesearch_color};
                }
                .searchform, .filter{
                    border-right-color: rgba(0, 0, 0, 0.2);
                    svg{
                        fill: ${variables.mobilesearch_color};
                    }
                }
                .filter, .listMenuSortby{
                    border-left-color: rgba(255, 255, 255, 0.2);
                    svg{
                        fill: ${variables.mobilesearch_color};
                    }
                }
                .closemenu{
                    fill:${variables.supplier_aside_button_background};
                }
            }
            .form{
                background: ${variables.searchbar_background};
                color:  ${variables.searchbar_color};
                .departure{
                    input{
                        border-color: ${variables.searchbar_input_border};
                        background-color: ${variables.searchbar_input_background};
                        color: ${variables.searchbar_input_color};
                    }
                }
                .select{
                    border-color: ${variables.searchbar_input_border};
                    background-color: ${variables.searchbar_input_background};
                    color: ${variables.searchbar_input_color};
                    svg{
                        fill: ${variables.searchbar_input_color};
                    }
                }
                .SingleDatePickerInput{
                    border-color: ${variables.searchbar_input_border};
                    background-color: ${variables.searchbar_input_background};
                    color: ${variables.searchbar_input_color};
                    svg{
                        fill: ${variables.searchbar_input_color};
                    }
                }
                .searchButton{
                    background: ${variables.searchbar_button_background};
                    color: ${variables.searchbar_button_color};
                    border: 1px solid ${variables.searchbar_button_border}
                    &:hover{
                        background: ${variables.searchbar_button_background_hover};
                        color: ${variables.searchbar_button_color_hover};
                    }
                }
                .numericStepper{
                    button, .Dropdown{
                        border-color: ${variables.searchbar_input_border};
                        background-color: ${variables.searchbar_input_background};
                        color: ${variables.searchbar_input_color};
                    }
                }
            }
            .content{
                .filter{
                    .head{
                        background-color: ${variables.lodginglist_filter_head_background};
                        color: ${variables.lodginglist_filter_head_color};
                    }
                    .MuiCheckbox-root.Mui-checked{
                        svg{
                            fill: ${variables.lodginglist_filter_content_checkbox_color};
                        }
                    }
                    &.byPrice{
                        .input-range{
                            .input-range__label{
                                color: ${variables.lodginglist_filter_content_slider_label_color};
                            }
                            .input-range__track{
                                background: ${variables.lodginglist_filter_content_slider_track_color};
                            }
                            .input-range__track--active{
                                background: ${variables.lodginglist_filter_content_slider_track_active_color};
                            }
                            .input-range__slider{
                                background: ${variables.lodginglist_filter_content_slider_track_point_background};
                                border-color: ${variables.lodginglist_filter_content_slider_track_point_border};
                            }
                        }
                    }
                    .MuiTypography-body1{
                        span{
                            color: ${variables.lodginglist_filter_neighborhood_color} !important;
                        }
                    }
                }
                .results{
                    .flightInfo{
                        .flight{
                            .itinerary .segment1{
                                .itineraryDuration{
                                    button{
                                        color: ${variables.flights_unit_details_color};
                                        background: ${variables.flights_unit_details_background};
                                        border-color: ${variables.flights_unit_details_border};
                                    }
                                }
                            }
                            .bookNow{
                                button{
                                    color: ${variables.flights_unit_booknow_color};
                                    background: ${variables.flights_unit_booknow_background};
                                    border-color: ${variables.flights_unit_booknow_border};
                                    &:hover{
                                        color: ${variables.flights_unit_booknow_color_hover};
                                        background: ${variables.flights_unit_booknow_background_hover};
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        .rooms, .groups{
            .item{
                &.lodging{
                    border-color: ${variables.item_lodging_border_color};
                    .content{
                        .titleWrap{
                            .title{
                                color: ${variables.item_lodging_title_color};
                            }
                        }
                        .descriptionWrap{
                            .description{
                                color: ${variables.item_lodging_description_color};
                                .toggler{
                                    color: ${variables.item_lodging_description_link_color};
                                }
                            }
                        }
                        .locationWrap{
                            svg{
                                color: ${variables.item_lodging_village_icon_color};
                            }
                            span{
                                color: ${variables.item_lodging_village_text_color};
                            }
                        }
                    }
                    .pricing{
                        .main-cta{
                            .primary{
                                background: ${variables.item_lodging_primary_cta_background};
                                color: ${variables.item_lodging_primary_cta_color};
                                border-color: ${variables.item_lodging_primary_cta_border};
                                svg{
                                    fill:${variables.item_lodging_primary_cta_color};
                                }
                                &:hover{
                                    background: ${variables.item_lodging_primary_cta_background_hover};
                                    color: ${variables.item_lodging_primary_cta_color_hover};
                                    svg{
                                        fill:${variables.item_lodging_primary_cta_color_hover};
                                    }
                                }
                            }
                        }
                    }
                }
                &.lodgingDetails{
                    border-color: ${variables.item_lodging_border_color};
                    .tabWrapper{
                        .tabBar{
                            color: ${variables.tabbar_color};
                            .tabsMenu{
                                .tabOption{
                                    &.Mui-selected{
                                        background-color: ${variables.tabbar_selected_background};
                                        color: ${variables.tabbar_selected_color};
                                        border-color: ${variables.tabbar_selected_border};
                                    }
                                }
                            }
                        }
                        .tabPanes{
                            background-color: ${variables.tabbar_pane_background};
                            border-color: ${variables.tabbar_pane_border};
                            .tabPane{
                                border-color: ${variables.tabbar_pane_border};
                                .content{
                                    .titleWrap{
                                        .title{
                                            color: ${variables.item_lodging_unit_title_color};
                                        }
                                    }
                                    .descriptionWrap{
                                        .description{
                                            color: ${variables.item_lodging_unit_description_color};
                                            .toggler{
                                                color: ${variables.item_lodging_unit_description_link_color};
                                            }
                                        }
                                    }
                                }
                                .pricing{
                                    .main-cta{
                                        .primary{
                                            background: ${variables.item_lodging_unit_primary_cta_background};
                                            color: ${variables.item_lodging_unit_primary_cta_color};
                                            border-color: ${variables.item_lodging_unit_primary_cta_border};
                                            svg{
                                                fill: ${variables.item_lodging_unit_primary_cta_color};
                                            }
                                            &:hover{
                                                background: ${variables.item_lodging_unit_primary_cta_background_hover};
                                                color: ${variables.item_lodging_unit_primary_cta_color_hover}; 
                                                svg{
                                                    fill: ${variables.item_lodging_unit_primary_cta_color_hover};
                                                }
                                            }
                                        }
                                    }
                                }
                                .compact{
                                    .title{
                                        color: ${variables.item_lodging_unit_title_color};
                                    }
                                    .savings{
                                        color: ${variables.item_lodging_unit_savings_color};
                                    }
                                    button{
                                        background: ${variables.item_lodging_unit_primary_cta_background};
                                        color: ${variables.item_lodging_unit_primary_cta_color};
                                        border: 1px solid ${variables.item_lodging_unit_primary_cta_border};
                                        &:hover{
                                            background: ${variables.item_lodging_unit_primary_cta_background_hover};
                                            color: ${variables.item_lodging_unit_primary_cta_color_hover};
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                .roomCell .item .pricing .main-cta .primary{
                    svg{
                        fill: ${variables.item_lodging_unit_selectoffer_cta_color};
                    }
                }
                .roomCell .item.roomDetails .tabWrapperRoom .tabPanes .tabPane .packages .package .content .booknow .book,
                .roomCell .item.roomDetails .tabWrapperRoom .tabPanes .tabPane .packages .room .content .booknow .book{
                    background: ${variables.item_lodging_unit_selectoffer_cta_background};
                    color: ${variables.item_lodging_unit_selectoffer_cta_color};
                    border-color: ${variables.item_lodging_unit_selectoffer_cta_border_color};
                    svg{
                        fill: ${variables.item_lodging_unit_selectoffer_cta_color};
                    }
                    &:hover{
                        background: ${variables.item_lodging_unit_selectoffer_cta_background_hover};
                        color: ${variables.item_lodging_unit_selectoffer_cta_color_hover};
                        svg{
                            fill: ${variables.item_lodging_unit_selectoffer_cta_color_hover};
                        }
                    }
                }


                .roomCell .item.roomDetails .tabWrapperRoom .tabPanes .tabPane .rooms .room .content .booknow .book,
                .roomCell .item.roomDetails .tabWrapperRoom .tabPanes .tabPane .rooms .package .content .booknow .book{
                    background: ${variables.item_lodging_unit_booknow_cta_background};
                    color: ${variables.item_lodging_unit_booknow_cta_color};
                    border-color: ${variables.item_lodging_unit_booknow_cta_border_color};
                    &:hover{
                        background: ${variables.item_lodging_unit_booknow_cta_background_hover};
                        color: ${variables.item_lodging_unit_booknow_cta_color_hover};
                    }
                }

                .package, .room {
                    .savings {
                        color: ${variables.item_lodging_unit_savings_color};
                    }
                }

                &.activities, &.merchandise, &.carRentals{
                    border-color: ${variables.item_activities_border_color};
                    .content{
                        .titleWrap{
                            .title{
                                color: ${variables.item_activities_title_color};
                            }
                        }
                        .descriptionWrap{
                            .description{
                                color: ${variables.item_activities_description_color};
                                .toggler{
                                    color: ${variables.item_activities_description_link_color};
                                }
                            }
                        }
                        .pricing{
                            .main-cta{
                                .primary{
                                    background: ${variables.item_activities_primary_cta_background};
                                    color: ${variables.item_activities_primary_cta_color};
                                    border-color: ${variables.item_activities_primary_cta_border};
                                    &:hover{
                                        background: ${variables.item_activities_primary_cta_background_hover}; 
                                        color: ${variables.item_activities_primary_cta_color_hover};
                                        svg{
                                            fill: ${variables.item_activities_primary_cta_color_hover};
                                        }
                                    }
                                    svg{
                                        fill: ${variables.item_activities_primary_cta_color};
                                    }
                                }
                            }
                        }
                    }
                    .pricing{
                        .main-cta{
                            .primary{
                                background: ${variables.item_activities_primary_cta_background};
                                color: ${variables.item_activities_primary_cta_color};
                                border-color: ${variables.item_activities_primary_cta_border};
                                &:hover{
                                    background: ${variables.item_activities_primary_cta_background_hover}; 
                                    color: ${variables.item_activities_primary_cta_color_hover};
                                    svg{
                                        fill: ${variables.item_activities_primary_cta_color_hover};
                                    }
                                }
                                svg{
                                    fill: ${variables.item_activities_primary_cta_color};
                                }
                            }
                        }
                    }
                }
                &.inapp{
                    border-color: ${variables.item_inapp_border_color};
                    .content{
                        .titleWrap{
                            .title{
                                color: ${variables.item_inapp_title_color};
                            }
                        }
                        .descriptionWrap{
                            .description{
                                color: ${variables.item_inapp_description_color};
                                .toggler{
                                    color: ${variables.item_inapp_description_link_color};
                                }
                            }
                        }
                    }
                    .pricing{
                        .main-cta{
                            .primary{
                                background: ${variables.item_inapp_primary_cta_background};
                                color: ${variables.item_inapp_primary_cta_color};
                                border-color: ${variables.item_inapp_primary_cta_border};
                                svg{
                                    fill: ${variables.item_inapp_primary_cta_color};
                                }
                            }
                        }
                    }
                }
                &.activitiesDetails, &.merchandiseDetails, &.carRentalsDetails{
                    border-color: ${variables.item_activities_border_color};
                    .tabWrapper{
                        .tabBar{
                            color: ${variables.tabbar_color};
                            .tabsMenu{
                                .tabOption{
                                    &.Mui-selected{
                                        background-color: ${variables.tabbar_selected_background};
                                        color: ${variables.tabbar_selected_color};
                                        border-color: ${variables.tabbar_selected_border};
                                    }
                                }
                            }
                        }
                        .tabPanes{
                            background-color: ${variables.tabbar_pane_background};
                            border-color: ${variables.tabbar_pane_border};
                            .tabPane{
                                border-color: ${variables.tabbar_pane_border};
                                .content{
                                    .titleWrap{
                                        .title{
                                            color: ${variables.item_activities_unit_title_color};
                                        }
                                    }
                                    .descriptionWrap{
                                        .description{
                                            color: ${variables.item_activities_unit_description_color};
                                            .toggler{
                                                color: ${variables.item_activities_unit_description_link_color};
                                            }
                                        }
                                    }
                                }
                                .pricing{
                                    .main-cta{
                                        .primary{
                                            background: ${variables.item_activities_unit_primary_cta_background};
                                            color: ${variables.item_activities_unit_primary_cta_color};
                                            border-color: ${variables.item_activities_unit_primary_cta_border};
                                            &:hover{
                                                background: ${variables.item_activities_unit_primary_cta_background_hover};
                                                color: ${variables.item_activities_unit_primary_cta_color_hover};
                                            }
                                        }
                                    }
                                }
                                .options {
                                    .headers{
                                        .title, .amount, .price{
                                            color: ${variables.item_activities_unit_headers_color};
                                        }
                                    }
                                    .values{
                                        .product, .mobileProduct{
                                            .groupTitle .cellTitle{
                                                color: ${variables.item_activities_unit_title_color};
                                            }
                                            .book{
                                                background: ${variables.item_activities_unit_primary_cta_background};
                                                color: ${variables.item_activities_unit_primary_cta_color};
                                                border-color: ${variables.item_activities_unit_primary_cta_border};
                                                &:hover{
                                                    background: ${variables.item_activities_unit_primary_cta_background_hover};
                                                    color: ${variables.item_activities_unit_primary_cta_color_hover};
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                &.inappDetails{
                    border-color: ${variables.item_inapp_border_color};
                    .tabWrapper{
                        .tabBar{
                            color: ${variables.tabbar_color};
                            .tabsMenu{
                                .tabOption{
                                    &.Mui-selected{
                                        background-color: ${variables.tabbar_selected_background};
                                        color: ${variables.tabbar_selected_color};
                                        border-color: ${variables.tabbar_selected_border};
                                    }
                                }
                            }
                        }
                        .tabPanes{
                            background-color: ${variables.tabbar_pane_background};
                            border-color: ${variables.tabbar_pane_border};
                            .tabPane{
                                border-color: ${variables.tabbar_pane_border};
                                .content{
                                    .titleWrap{
                                        .title{
                                            color: ${variables.item_inapp_unit_title_color};
                                        }
                                    }
                                    .descriptionWrap{
                                        .description{
                                            color: ${variables.item_inapp_unit_description_color};
                                            .toggler{
                                                color: ${variables.item_inapp_unit_description_link_color};
                                            }
                                        }
                                    }
                                }
                                .pricing{
                                    .main-cta{
                                        .primary{
                                            background: ${variables.item_inapp_unit_primary_cta_background};
                                            color: ${variables.item_inapp_unit_primary_cta_color};
                                        }
                                    }
                                }
                                .options {
                                    .headers{
                                        .title, .amount, .price{
                                            color: ${variables.item_inapp_unit_headers_color};
                                        }
                                    }
                                    .values{
                                        .product, .mobileProduct{
                                            .groupTitle .cellTitle{
                                                color: ${variables.item_inapp_unit_title_color};
                                            }
                                            .book{
                                                background: ${variables.item_inapp_unit_primary_cta_background};
                                                color: ${variables.item_inapp_unit_primary_cta_color};
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        .summaryCart{
            .topBar{
                color: ${variables.summarycart_general_color};
                background-color: ${variables.summarycart_general_background};
            }
            .products{
                background-color: ${variables.summarycart_product_background};
                .agrupation{
                    .header{
                        background-color: ${variables.summarycart_group_background};
                        color: ${variables.summarycart_group_color};
                    }
                }
                .product{
                    border-color: ${variables.summarycart_product_border};
                    .item{
                        .content{
                            .names{
                                .supplierName{
                                }
                                .productName{
                                }
                            }
                            .options{
                                svg{
                                    background-color: ${variables.summarycart_remove_background};
                                    color: ${variables.summarycart_remove_color};
                                }
                            }
                        }
                        .dateqty{
                            .dates, .guests{
                                color: ${variables.summarycart_product_dateguest_color};
                                span{
                                    color: ${variables.summarycart_product_dateguest_span_color};
                                }
                            }
                        }
                    }
                }
            }
            .summary{
                color: #333333;
                background-color: #ffffff;
                border-color: ${variables.summarycart_general_background};
                .summaryLine.savings {
                    color: ${variables.item_lodging_unit_savings_color};
                }
            }
            .footer{
                background: ${variables.summarycart_cta_background};
                color: ${variables.summarycart_cta_color};
                border: 1px solid ${variables.summarycart_cta_border}; 
                &:hover{
                    background: ${variables.summarycart_cta_background_hover};
                    color: ${variables.summarycart_cta_color_hover}; 
                }
            }
        }
        .packagesSection{
            .content{
                .results{
                    background-color: ${variables.packages_list_background};
                }
                .list{
                    .item{
                        &.package{
                            .content{
                                .titleWrap{
                                    color: ${variables.packages_item_title};
                                }
                                .descriptionWrap{
                                    .description{
                                        color: ${variables.packages_item_description};
                                        .toggler{
                                            color: ${variables.packages_item_description_link_color};
                                        }
                                    }
                                }
                            }
                            .pricing{
                                .main-cta{
                                    .primary{
                                        background: ${variables.packages_item_cta_background};
                                        color: ${variables.packages_item_cta_color};
                                        border-color: ${variables.packages_item_cta_border};
                                        &:hover{
                                            background: ${variables.packages_item_cta_background_hover}
                                            color: ${variables.packages_item_cta_color_hover}
                                        }
                                        a{
                                            color: ${variables.packages_item_cta_color};
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        .packageSection{
            .content{
                .results{
                    background-color: ${variables.package_background};
                    .searchBox{
                        .DateRangePickerInput{
                            .DateInput_input{
                                background-color: ${variables.package_search_background};
                            }
                        }
                    }
                }
                .results{
                    .list{
                        .package{
                            .header{
                                color: ${variables.package_title_color};
                            }
                            .information{
                                color: ${variables.package_description_color};
                                .toggler{
                                    color: ${variables.package_description_link_color};
                                }
                            }
                            .mobilesearch{
                                .searchAction{
                                    background-color: ${variables.mobilesearch_background};
                                    color: ${variables.mobilesearch_color};
                                }
                                .closemenu{
                                    fill:${variables.supplier_aside_button_background};
                                }
                            }
                            .searchBox{
                                &.completedDates{
                                    .DateInput{
                                        input{
                                            color: ${variables.package_aside_header_color};
                                        }
                                        background-color: ${variables.package_aside_header_background};
                                    }
                                    svg{
                                        fill: ${variables.package_aside_header_color};
                                    }
                                }
                                .guest{
                                    &:not(.empty){
                                        .numericStepper{
                                            .bigDropDown{
                                                color: ${variables.package_aside_header_color};
                                            }
                                        }
                                        background-color: ${variables.package_aside_header_background};
                                        svg{
                                            fill: ${variables.package_aside_header_color};
                                        }
                                    }
                                }
                                .searchButton{
                                    &:not(.disabled){
                                        background: ${variables.package_aside_cta_background};
                                        color: ${variables.package_aside_cta_color};
                                        border: 1px solid ${variables.package_aside_cta_border};
                                        &:hover{
                                            background: ${variables.package_aside_cta_background_hover};
                                            color: ${variables.package_aside_cta_color_hover};
                                        }
                                    }
                                }
                            }
                            .package-navbar{
                                background-color: ${variables.package_components_navbar_background};
                                .required{
                                    border-top-color: ${variables.package_components_navbar_required_border};
                                }
                                .optional{
                                    border-top-color: ${variables.package_components_navbar_optional_border};
                                }
                                .MuiTabs-scrollButtons{
                                    background-color: ${variables.package_components_navbar_scrollbuttons_background};
                                    border-color: ${variables.package_components_navbar_scrollbuttons_border};
                                }
                                .MuiTab-textColorPrimary{
                                    background-color: ${variables.package_components_navbar_tab_background};
                                    color: ${variables.package_components_navbar_tab_color};
                                    border-left-color: ${variables.package_components_navbar_tab_border_left};
                                    border-right-color: ${variables.package_components_navbar_tab_border_right};
                                }
                                .Mui-selected{
                                    color: ${variables.package_components_navbar_tab_active_color};
                                    background-color: ${variables.package_components_navbar_tab_active_background};
                                    svg{
                                        color: ${variables.package_components_navbar_tab_active_icon_color};
                                        background-color: ${variables.package_components_navbar_tab_active_icon_background};
                                    }
                                }
                            }
                            .components{
                                .searchMessage{
                                    &.informative{
                                        border-left-color: ${variables.package_component_date_border};
                                    }
                                }
                                .tabPanes{
                                    border-color: ${variables.package_component_pane_border};
                                    .component{
                                        .dates{
                                            border-color: ${variables.package_component_date_border};
                                            .selectedDate{
                                                color: ${variables.package_component_dates_selected_color};
                                            }
                                            .availableDate{}
                                        }
                                    }
                                }
                            }
                            .aside{
                                .summaryCart{
                                    .header{
                                        background-color: ${variables.package_aside_header_background};
                                        color: ${variables.package_aside_header_color};
                                    }
                                    .body{
                                        svg{
                                            fill: ${variables.package_aside_header_background};
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        .cartSection{
            background-color: ${variables.cart_background};
            .topBar{
                .title{
                    color: ${variables.cart_header_title_color};
                }
                .itinerary-id{
                    .SaveItineraryButton{
                        button{
                            background-color: ${variables.cart_header_itinerary_save_background_color};
                            border-color: ${variables.cart_header_itinerary_save_background_color};
                            color: ${variables.cart_header_itinerary_save_color};
                        }
                    }
                    .continue{
                        background-color: ${variables.cart_header_itinerary_save_background_color};
                        border-color: ${variables.cart_header_itinerary_save_background_color};
                        color: ${variables.cart_header_itinerary_save_color};
                    }
                }
            }

            .itinerary-id{
                color: ${variables.cart_header_itinerary_color};
                .save{
                    color: ${variables.cart_header_itinerary_save_color};
                }
            }

            .products{
                .agrupation{
                    .header{
                        background-color: ${variables.cart_group_background};
                        color: ${variables.cart_group_color};
                    }
                    .product{
                        background-color: ${variables.cart_product_background};
                        .multimedia{
                            background-color: ${variables.cart_product_photo_background};
                            .icon{
                                fill: ${variables.cart_product_photo_icon_color};
                            }
                        }
                        .content{
                            .supplierName{
                                color: ${variables.cart_product_supplier_color};
                            }
                            .productName{
                                color: ${variables.cart_product_product_color};
                            }
                            .date, .qty, .location{
                                color: ${variables.cart_product_datequantity_color};
                            }
                        }
                        .sideinfo{
                            .remove{
                                background-color: ${variables.cart_product_remove_background};
                                color: ${variables.cart_product_remove_color};
                                svg{
                                    fill: ${variables.cart_product_remove_color};
                                }
                            }
                            .price{
                                .savings{
                                    color: ${variables.cart_product_savings_color};
                                }
                            }
                            p{
                                color: ${variables.cart_product_selected_package_color};
                            }
                        }
                    }
                }
                .bundle{
                    background-color: ${variables.cart_product_background};
                }
            }

            .bottom{
                .upselling{
                    background-color: ${variables.cart_upselling_background};
                    h3{
                        &.topTitle{
                            color: ${variables.cart_upselling_top_title_color};
                        }
                        &.bottomTitle{
                            color: ${variables.cart_upselling_bottom_title_color};
                        }
                    }
                    .container{
                        button,
                        .headerTab{
                            color: ${variables.cart_upselling_category_color};
                            svg{
                                fill: ${variables.cart_upselling_category_icon_color};
                            }
                            &:hover{
                                color: ${variables.cart_upselling_category_hover_color};
                                svg{
                                    fill: ${variables.cart_upselling_category_icon_hover_color};
                                }
                            }
                        }
                    }
                }
                .summary{
                    .summaryName, .taxes{
                        color: ${variables.cart_summary_subtotal};
                        &.total{
                            background-color: ${variables.cart_summary_total_background};
                        }
                    }
                    .taxes{
                        color: ${variables.cart_summary_taxes_link_color};
                    }
                    .totalDueNow{
                        color: ${variables.cart_summary_subtotal};
                    }
                }
            }
            .extraComponents{
                .attachPromocode{
                    .label{
                        color: ${variables.cart_attachpromocode_label_color};
                    }
                    button{
                        &.apply{
                            background: ${variables.cart_attachpromocode_cta_background};
                            color: ${variables.cart_attachpromocode_cta_color};
                            &:hover{
                                background: ${variables.cart_attachpromocode_cta_background};
                                color: ${variables.cart_attachpromocode_cta_color};
                            }
                        }
                    }
                }
            }
            .checkout{
                .goToCheckout{
                    border-color: ${variables.checkout_buttons_cart_border};
                    background: ${variables.checkout_buttons_cart_background};
                    color: ${variables.checkout_buttons_cart_color};
                    &:hover{
                        background: ${variables.checkout_buttons_cart_hover_background};
                        color: ${variables.checkout_buttons_cart_hover_color};
                        svg{
                            fill: ${variables.checkout_buttons_cart_hover_color};
                        }
                    }
                    svg{
                        fill: ${variables.checkout_buttons_cart_color};
                    }
                }
            }
        }
        .suppliersSection{
            .content{
                .results{
                    .list{
                        .item{
                            .pricing{
                                .main-cta{
                                    &:hover{
                                        a{
                                            color: ${variables.suppliers_link_hover_color};
                                        }
                                        svg{
                                            fill: ${variables.suppliers_link_hover_color};
                                        }
                                    }
                                    a, svg{
                                        color: ${variables.suppliers_link_color};
                                        fill: ${variables.suppliers_link_color};
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        .supplierSection{
            .content{
                .result{
                    .header{
                        .title-address{
                            .title{
                                color: ${variables.supplier_title_color};
                            }
                            .address{
                                color: ${variables.supplier_address_color};
                                span{
                                    color: ${variables.supplier_address_link_color};
                                }
                            }
                        }
                    }
                    .item{
                        &.lodgingDetails{
                            border-color: ${variables.item_lodging_border_color};
                            .tabWrapper{
                                .tabBar{
                                    color: ${variables.tabbar_color};
                                    .tabsMenu{
                                        .tabOption{
                                            &.Mui-selected{
                                                background-color: ${variables.tabbar_selected_background};
                                                color: ${variables.tabbar_selected_color};
                                                border-color: ${variables.tabbar_selected_border};
                                            }
                                        }
                                    }
                                }
                                .tabPanes{
                                    background-color: ${variables.tabbar_pane_background};
                                    border-color: ${variables.tabbar_pane_border};
                                    .tabPane{
                                        border-color: ${variables.tabbar_pane_border};
                                        .content{
                                            .titleWrap{
                                                .title{
                                                    color: ${variables.item_lodging_unit_title_color};
                                                }
                                            }
                                            .descriptionWrap{
                                                .description{
                                                    color: ${variables.item_lodging_unit_description_color};
                                                    .toggler{
                                                        color: ${variables.item_lodging_unit_description_link_color};
                                                    }
                                                }
                                            }
                                            .booknow{
                                                button{
                                                    background: ${variables.item_lodging_unit_booknow_cta_background};
                                                    color: ${variables.item_lodging_unit_booknow_cta_color};
                                                    border-color: ${variables.item_lodging_unit_booknow_cta_border_color};
                                                    svg{
                                                        fill: ${variables.item_lodging_unit_booknow_cta_color};
                                                    }
                                                }
                                            }
                                        }
                                        .pricing{
                                            .main-cta{
                                                .primary{
                                                    background: ${variables.item_lodging_unit_primary_cta_background};
                                                    color: ${variables.item_lodging_unit_primary_cta_color};
                                                    border-color: ${variables.item_lodging_primary_cta_border};
                                                }
                                                svg{
                                                    fill: ${variables.item_lodging_unit_primary_cta_color};
                                                }
                                            }
                                        }
                                        .compact{
                                            .title{
                                                color: ${variables.item_lodging_unit_title_color};
                                            }
                                            .savings{
                                                color: ${variables.item_lodging_unit_savings_color};
                                            }
                                            button{
                                                background: ${variables.item_lodging_unit_primary_cta_background};
                                                color: ${variables.item_lodging_unit_primary_cta_color};
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
            .sidebar{
                .searchBox{
                    .searchButton{
                        background: ${variables.supplier_aside_button_background};
                        border-color: ${variables.supplier_aside_button_border};
                        color: ${variables.supplier_aside_button_color};
                    }
                    .nights{
                        .numericStepper{
                            .Dropdown{
                                color: black;
                            }
                        }
                    }
                    .guestsSelector{
                        .guest{
                            .numericStepper{
                                .Dropdown{
                                    color: black;
                                }
                            }
                        }
                    }
                }
            }
            .searchBox{
                .searchBar{
                    background: ${variables.supplier_aside_button_background};
                    border-color: ${variables.supplier_aside_button_border};
                    color: ${variables.supplier_aside_button_color};
                }
                .searchDrawer{
                    .searchAction{
                        background: ${variables.supplier_aside_button_background};
                        border-color: ${variables.supplier_aside_button_border};
                        color: ${variables.supplier_aside_button_color};
                    }
                }
            }
        }
        .registerSection, .paymentSection, .reviewSection[class], .customerRequirementsWrapper > .customerRequirementsSection{
            .ctaLogin, .ctaRegister, .ctaUpdate, .active[class]{
                background: ${variables.checkout_buttons_cart_background};
                color: ${variables.checkout_buttons_cart_color};
                border: 1px solid ${variables.checkout_buttons_cart_border};
                svg{
                    fill: ${variables.checkout_buttons_cart_color};
                }
                &:hover{
                    background: ${variables.checkout_buttons_cart_hover_background};
                    color: ${variables.checkout_buttons_cart_hover_color};
                    svg{
                        fill: ${variables.checkout_buttons_cart_hover_color};
                    }
                }
            }
            .unactive{
                svg{
                    fill: ${variables.checkout_button_color};
                }
            }
            .products{
                .product{
                    .buttons{
                        button{
                            border-color: ${variables.checkout_customer_requirement_button_border};
                        }
                    }
                }
            }
            
        }
        .payment{
            .paymentSection{
                .formFooter{
                    .save{
                        button{
                            background-color:${variables.checkout_button_background};
                            color:${variables.checkout_button_color};
                            border-color:${variables.checkout_button_border};
                            svg{
                                fill: ${variables.checkout_button_color};
                            }
                            &:hover{
                                background-color:${variables.checkout_button_border};
                                border-color:${variables.checkout_button_background};
                            }
                        }
                    }
                }
            }
            
        }
        .LoginPage{
            .Login{
                form{
                    .SubmitForm{
                        background: ${variables.login_button_background};
                        color: ${variables.login_button_color};
                        border: 1px solid ${variables.login_button_border};
                        svg{
                            fill: ${variables.login_button_color};
                        }
                        &:hover{
                            background: ${variables.login_button_background_hover};
                            color: ${variables.login_button_color_hover};
                            svg{
                                fill: ${variables.login_button_color_hover};
                            }
                        }
                    }
                }
            }
        }
        .generalModal{
            background-color: ${variables.modal_background};
            .header{
                background-color: ${variables.modal_header_background};
                color: ${variables.modal_header_color};
                svg{
                    fill: ${variables.modal_header_icon_color};
                }
            }
            .footer{
                background-color: ${variables.modal_footer_background};
                .primary {
                    color: ${variables.modal_footer_cta_primary_color};
                    background: ${variables.modal_footer_cta_primary_background};
                    border-color: ${variables.modal_footer_cta_primary_border};
                    a{
                        color: ${variables.modal_footer_cta_primary_color};
                    }
                    &:hover{
                        background: ${variables.modal_footer_cta_primary_background_hover};
                        color: ${variables.modal_footer_cta_primary_color_hover};
                    }
                }
                .secondary {
                    color: ${variables.modal_footer_cta_secondary_color};
                    background-color: ${variables.modal_footer_cta_secondary_background};
                    border-color: ${variables.modal_footer_cta_secondary_border};
                    &:hover{
                        background: ${variables.modal_footer_cta_secondary_background_hover};
                        color: ${variables.modal_footer_cta_secondary_color_hover};
                    }
                }
            }
        }
        .mobileCartSection{
            .checkout{
                button{
                    background-color: ${variables.cart_mobile_bottom_cta_background};
                    color: ${variables.cart_mobile_bottom_cta_color};
                }
            }
        }
        .numericStepper{
            button{
                &.primary{
                    border-color: ${variables.stepper_border};
                    color: ${variables.stepper_color};
                    background-color: ${variables.stepper_background};
                }
            }
            .Dropdown, .Dropdown:before, .Dropdown:after {
                color: ${variables.stepper_dropdown_color};
                background-color: ${variables.stepper_dropdown_background};
                #select-ammount{
                    color: ${variables.stepper_dropdown_color};
                    background-color: ${variables.stepper_dropdown_background};
                }
            }
            .bigDropDown{
                color: ${variables.stepper_dropdown_color};
                background-color: ${variables.stepper_dropdown_background};
                border-color: ${variables.stepper_dropdown_border};
                svg{
                    fill: ${variables.stepper_dropdown_color};
                }
                &.default{
                    color: ${variables.item_activities_stepper_color};
                    background-color: ${variables.item_activities_stepper_background_color};
                    border-color: ${variables.item_activities_stepper_border_color};
                    svg{
                        fill: ${variables.item_activities_stepper_bullet_fill_color};
                    }
                }
            }
        }
        .quantitySelectorWrapper{
            .quantitySelector{
                color: ${variables.stepper_dropdown_color};
                background-color: ${variables.stepper_dropdown_background};
                border-color: ${variables.stepper_dropdown_border};
                svg{
                    fill: ${variables.stepper_dropdown_color};
                }
                &.default{
                    color: ${variables.item_activities_stepper_color};
                    background-color: ${variables.item_activities_stepper_background_color};
                    border-color: ${variables.item_activities_stepper_border_color};
                    svg{
                        fill: ${variables.item_activities_stepper_bullet_fill_color};
                    }
                }
            }
        }
        .liftTicketsSection{
            .SingleDatePicker .SingleDatePicker_picker .DayPicker > div > div:first-child .DayPicker_weekHeaders__horizontal .DayPicker_weekHeader ul{
                background-color: ${variables.yieldview_calendar_head_background};
                color: ${variables.yieldview_calendar_head_color};
            }
            .SingleDatePicker .ValidWrapper{
                background-color: ${variables.yieldview_calendar_valid_background};
            }
            .Valid{
                .savings {
                    background-color: ${variables.yieldview_calendar_savings_background};
                }
                .savings, .savings .priceWrap .currency, .savings .priceWrap .price {
                    color: ${variables.yieldview_calendar_savings_color};
                }
                .priceWrap{
                    color:${variables.yieldview_calendar_price};
                }
            }
        }
        .liftTicketDaySection{
            .book{
                background-color: ${variables.yieldview_product_cta_primary_background};
                color: ${variables.yieldview_product_cta_primary_color};
            }
        }
        .footerWrapper{
            background-color: ${variables.footer_background};
            .container{
                .column{
                    .links{
                        ul{
                            li{
                                a{
                                    color: ${variables.footer_link_color};
                                    &:hover{
                                        color: ${variables.footer_link_hover_color};
                                    }
                                }
                            }
                        }
                    }
                    .title{
                        color: ${variables.footer_title_color};
                    }
                    .text{
                        color: ${variables.footer_text_color};
                        .title{
                            color: ${variables.footer_title_color};
                        }
                        strong{
                            color: ${variables.footer_bold_color};
                        }
                        a{
                            color: ${variables.footer_link_color};
                            &:hover{
                                color: ${variables.footer_link_hover_color};
                            }
                        }
                    }
                }
            }
        }
        .socketWrapper{
            background-color: ${variables.socket_background};
            .container{
                .poweredBySpotlio{
                    span{
                        color: ${variables.socket_color};
                    }
                }
            }
        }
        .notFound{
            .notFoundTitle{
                color: ${variables.notFound_title}
            }
            .notFoundSubtitle{
                color: ${variables.notFound_subtitle}
            }
            .container{
                a{
                    color: ${variables.notFound_tab_label}
                    svg{
                        fill: ${variables.notFound_tab_icon}
                    }
                }
            }
        }
    `;
}
